import merge from 'lodash/merge'
import baseButtonStyles from '../BaseButton/BaseButton.styles'
import parseTypography from '@converdy/styles/parsers/parse-typography'
import { parseResponsiveProperty } from '@converdy/styles'

export default function headerStyles(scope, {
  buttonPrimary,
  buttonSecondary,
  navigationTypography,
  height,
  background,
  hamburgerColor,
  logoWidth,
  textLogoTypography
}) {
  
  let jss = {
    [`${scope} .button-primary`]: baseButtonStyles(buttonPrimary),
    [`${scope} .button-secondary`]: baseButtonStyles(buttonSecondary),
    [`${scope} .navigation`]: parseTypography(navigationTypography),
    [`${scope} .bars`]: {
      'color': hamburgerColor
    },
    [`${scope} .logo`]: {
      ...parseTypography(textLogoTypography)
    },
    [`${scope} img.logo`]: {
      ...parseResponsiveProperty(v => {
        return v && v.value && v.unit ? {
          maxWidth: v.value + v.unit,
        } : {} 
      }, logoWidth)
    },
    [`${scope} .inner`]: {
      ...parseResponsiveProperty(v => {
        return v && v.value && v.unit ? {
          minHeight: v.value + v.unit,
        } : {} 
      }, height)
    },
    [`${scope}`]: {
      background
    },
  }

  return jss
}